var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ShiciGameLayout",
    [
      _c(
        "div",
        { staticClass: "control-section" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "start-btn",
                      attrs: { type: "primary", loading: _vm.isLoading },
                      on: { click: _vm.startGame },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isLoading ? "加载中..." : "开始游戏") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "score-col", attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c("span", { staticClass: "score-text" }, [
                    _vm._v("当前得分: " + _vm._s(_vm.score)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.gameStarted
        ? _c("div", { staticClass: "game-section" }, [
            _c("div", { staticClass: "question-card" }, [
              _c("div", { staticClass: "question-header" }, [
                _c("h2", { staticClass: "question-title" }, [
                  _vm._v(
                    "第 " +
                      _vm._s(_vm.currentQuestionIndex + 1) +
                      " 题 / 共 " +
                      _vm._s(_vm.questions.length) +
                      " 题"
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "question-type" }, [
                  _vm._v(_vm._s(_vm.questionTypeText)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "question-content" }, [
                _c("p", { staticClass: "question-text" }, [
                  _vm._v(_vm._s(_vm.displayQuestionText)),
                ]),
                _vm._v(" "),
                _vm.currentQuestion.poem &&
                (_vm.currentQuestion.poem.title ||
                  _vm.currentQuestion.poem.author)
                  ? _c("p", { staticClass: "question-ref" }, [
                      _vm._v(
                        "\n          ——《" +
                          _vm._s(_vm.currentQuestion.poem.title) +
                          "》 " +
                          _vm._s(_vm.currentQuestion.poem.author) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "options-section" },
                _vm._l(_vm.currentQuestion.options, function (option, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      staticClass: "option-btn",
                      attrs: {
                        type:
                          _vm.selectedOption === index ? "primary" : "default",
                        disabled: _vm.showFeedback,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectOption(index)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(option) + "\n        ")]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "question-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "submit-btn",
                      attrs: {
                        disabled:
                          _vm.showFeedback ||
                          _vm.selectedOption === -1 ||
                          _vm.isSubmitting,
                        loading: _vm.isSubmitting,
                        type: "primary",
                      },
                      on: { click: _vm.submitAnswer },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isSubmitting ? "提交中..." : "提交答案") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.showFeedback
              ? _c("div", { staticClass: "feedback-card" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "feedback-header",
                        _vm.isCorrect ? "correct" : "incorrect",
                      ],
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.isCorrect ? "回答正确！" : "回答错误")
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "feedback-content" }, [
                    !_vm.isCorrect
                      ? _c("p", { staticClass: "correct-answer" }, [
                          _vm._v(
                            "正确答案: " + _vm._s(_vm.feedbackCorrectAnswer)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", { staticClass: "explanation" }, [
                      _vm._v(_vm._s(_vm.feedbackExplanation)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "poem-info" }, [
                      _c("div", { staticClass: "poem-header-row" }, [
                        _c("h4", { staticClass: "poem-title" }, [
                          _vm._v(_vm._s(_vm.currentQuestion.poem.title)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "poem-actions" },
                          [
                            _vm.isCurrentFavorite
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("已收藏")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.isCurrentFavorite
                                    ? "success"
                                    : "default",
                                  loading: _vm.isTogglingFavorite,
                                },
                                on: { click: _vm.toggleFavorite },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.isCurrentFavorite
                                        ? "取消收藏"
                                        : "收藏"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "author" }, [
                        _vm._v(_vm._s(_vm.currentQuestion.poem.author)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "poem-split" }, [
                        _c("div", { staticClass: "poem-left" }, [
                          _c(
                            "div",
                            { staticClass: "poem-content" },
                            _vm._l(
                              _vm.poemLinesForFeedback,
                              function (line, idx) {
                                return _c(
                                  "p",
                                  {
                                    key: idx,
                                    class: [
                                      "poem-line",
                                      line.isHighlight
                                        ? "poem-line-highlight"
                                        : "",
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(line.text) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "poem-right" }, [
                          _c("div", { staticClass: "annotation-title" }, [
                            _vm._v("注释"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "annotation-text" }, [
                            _vm._v(_vm._s(_vm.currentAnnotationText)),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "feedback-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "next-btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.nextQuestion },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.currentQuestionIndex <
                                  _vm.questions.length - 1
                                  ? "下一题"
                                  : "结束游戏"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.gameEnded
        ? _c("div", { staticClass: "game-over-section" }, [
            _c("div", { staticClass: "game-over-card" }, [
              _c("h2", { staticClass: "game-over-title" }, [
                _vm._v("游戏结束"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "game-over-content" }, [
                _c("p", { staticClass: "final-score" }, [
                  _vm._v(
                    "最终得分: " +
                      _vm._s(_vm.score) +
                      " / " +
                      _vm._s(_vm.questions.length)
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "accuracy" }, [
                  _vm._v(_vm._s(_vm.accuracy) + "% 正确率"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats" }, [
                  _c("span", [
                    _vm._v("正确: " + _vm._s(_vm.correctCount) + " 题"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("错误: " + _vm._s(_vm.incorrectCount) + " 题"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "game-over-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "restart-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.restartGame },
                    },
                    [_vm._v("\n          重新开始\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "从网络抓取诗词",
            visible: _vm.showFetchDialog,
            width: "400px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFetchDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "fetch-shici-form" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.fetchForm, "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "数量" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 10, step: 1 },
                        model: {
                          value: _vm.fetchForm.count,
                          callback: function ($$v) {
                            _vm.$set(_vm.fetchForm, "count", $$v)
                          },
                          expression: "fetchForm.count",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showFetchDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.isFetching },
                  on: { click: _vm.fetchShici },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isFetching ? "抓取中..." : "抓取") +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }